import { MAPPING_BOOKING_STATUS_PAGE } from "./conf/MAPPING_BOOKING_STATUS";
import { MAPPING_CHANNEL_PAGE } from "./conf/MAPPING_CHANNEL";
import { MAPPING_COMPETITOR_PAGE } from "./conf/MAPPING_COMPETITOR";
import { MAPPING_COUNTRY_PAGE } from "./conf/MAPPING_COUNTRY";
import { MAPPING_CUSTOMER_TYPE_PAGE } from "./conf/MAPPING_CUSTOMER_TYPE";
import { MAPPING_FARE_CODE_PAGE } from "./conf/MAPPING_FARE_CODE";
import { MAPPING_ADVANCED_GRID_TYPE_PAGE } from "./conf/MAPPING_GRID_MAPPING";
import { MAPPING_GRID_TYPE_PAGE } from "./conf/MAPPING_GRID_TYPE";
import { MAPPING_LOS_PAGE } from "./conf/MAPPING_LOS";
import { MAPPING_PROPERTY_PAGE } from "./conf/MAPPING_PROPERTY";
import { MAPPING_SEGMENT_PAGE } from "./conf/MAPPING_SEGMENT";
import { MAPPING_UH_CAT_PAGE } from "./conf/MAPPING_UH_CAT";
import { CUSTOM_KPIS_PAGE } from "./conf/CUSTOM_KPIS";
import { SETUP_AUTOPILOT_PAGE } from "./conf/SETUP_AUTOPILOT";
import { SETUP_BATCH_PAGE } from "./conf/SETUP_BATCH";
import { SETUP_BUDGET_PAGE } from "./conf/SETUP_BUDGET";
import { SETUP_BUSINESS_RULES_PAGE } from "./conf/SETUP_BUSINESS_RULES";
import { SETUP_CAPACITY_PAGE } from "./conf/SETUP_CAPACITY";
import { SETUP_CONNECTIVITY } from "./conf/SETUP_CONNECTIVITY";
import { SETUP_GENERAL_PAGE } from "./conf/SETUP_GENERAL";
import { SETUP_EVENT_PAGE } from "./conf/SETUP_EVENT";
import { SETUP_MODEL_PAGE } from "./conf/SETUP_MODEL";
import { SETUP_MODELS_PAGE } from "./conf/SETUP_MODELS_LIBRARY";
import { SETUP_SEASON_PAGE } from "./conf/SETUP_SEASON";
import { SETUP_PRICE_PAGE } from "./conf/SETUP_PRICE";
import { SETUP_PRICING_TIER_PAGE } from "./conf/SETUP_PRICING_TIER";
import { SETUP_TRASH_PAGE } from "./conf/SETUP_TRASH";
import { SURQUAL_BOOKING_STATUS_PAGE } from "./conf/SURQUAL_BOOKING_STATUS";
import { SETUP_COMPETITOR_SELECTION_PAGE } from "./conf/SETUP_COMPETITOR_SELECTION";
import { SURQUAL_COMPETITOR_PROPERTY_PAGE } from "./conf/SURQUAL_COMPETITOR";
import { SURQUAL_CHANNEL_PAGE } from "./conf/SURQUAL_CHANNEL";
import { SURQUAL_COUNTRY_PAGE } from "./conf/SURQUAL_COUNTRY";
import { SURQUAL_CUSTOMER_TYPE_PAGE } from "./conf/SURQUAL_CUSTOMER_TYPE";
import { SURQUAL_FARE_CODE_PAGE } from "./conf/SURQUAL_FARE_CODE";
import { SURQUAL_GRID_TYPE_PAGE } from "./conf/SURQUAL_GRID_TYPE";
import { SURQUAL_LOS_PAGE } from "./conf/SURQUAL_LOS";
import { SURQUAL_PROPERTY_PAGE } from "./conf/SURQUAL_PROPERTY";
import { SURQUAL_SEGMENT_PAGE } from "./conf/SURQUAL_SEGMENT";
import { SURQUAL_UH_CAT_PAGE } from "./conf/SURQUAL_UH_CAT";
import { ConfigurationSectionType } from "./interfaces";
// import { SETUP_MODELS_LIBRARY_PAGE } from "./conf/SETUP_MODELS_LIBRARY";
import { SETUP_GENERAL_PAGE_BLOC_MAIL_PAGE } from "./conf/SETUP_MAIL";
import { SETUP_CAPACITE_CUSTOM_PAGE } from "./conf/SETUP_CAPACITE_CUSTOM";

export const conf: { sections: ConfigurationSectionType[] } = {
  sections: [
    {
      path: "mapping",
      label: "MAPPING",
      pages: [
        MAPPING_PROPERTY_PAGE,
        MAPPING_UH_CAT_PAGE,
        MAPPING_BOOKING_STATUS_PAGE,
        MAPPING_CUSTOMER_TYPE_PAGE,
        MAPPING_SEGMENT_PAGE,
        MAPPING_CHANNEL_PAGE,
        MAPPING_GRID_TYPE_PAGE,
        MAPPING_ADVANCED_GRID_TYPE_PAGE,
        MAPPING_FARE_CODE_PAGE,
        MAPPING_LOS_PAGE,
        MAPPING_COUNTRY_PAGE,
      ],
    },
    {
      path: "overqualified",
      label: "SELF_MAPPING",
      pages: [
        SURQUAL_PROPERTY_PAGE,
        SURQUAL_UH_CAT_PAGE,
        SURQUAL_BOOKING_STATUS_PAGE,
        SURQUAL_CUSTOMER_TYPE_PAGE,
        SURQUAL_SEGMENT_PAGE,
        SURQUAL_CHANNEL_PAGE,
        SURQUAL_GRID_TYPE_PAGE,
        SURQUAL_FARE_CODE_PAGE,
        SURQUAL_LOS_PAGE,
        SURQUAL_COUNTRY_PAGE,
      ],
    },
    {
      path: "competitor",
      label: "COMPETITOR_SUBMENU_CONFIGURATION",
      pages: [
        MAPPING_COMPETITOR_PAGE,
        SURQUAL_COMPETITOR_PROPERTY_PAGE,
        SETUP_COMPETITOR_SELECTION_PAGE,
      ],
    },
    {
      path: "setting",
      label: "SETUP",
      pages: [
        SETUP_BUDGET_PAGE,
        SETUP_CAPACITY_PAGE,
        SETUP_GENERAL_PAGE_BLOC_MAIL_PAGE,
        SETUP_GENERAL_PAGE,
        SETUP_BATCH_PAGE,
        SETUP_EVENT_PAGE,
        // SETUP_MODELS_LIBRARY_PAGE,
        SETUP_MODELS_PAGE,
        SETUP_MODEL_PAGE,
        SETUP_PRICE_PAGE,
        SETUP_PRICING_TIER_PAGE,
        SETUP_SEASON_PAGE,
        SETUP_AUTOPILOT_PAGE,
        SETUP_BUSINESS_RULES_PAGE,
        SETUP_CONNECTIVITY,
        CUSTOM_KPIS_PAGE,
        SETUP_CAPACITE_CUSTOM_PAGE,
        SETUP_TRASH_PAGE,
      ],
    },
  ],
} as { sections: ConfigurationSectionType[] };
